import React, { useState, useEffect } from "react"
import { Divider, Button } from "antd"
import { PlusOutlined } from "@ant-design/icons"
import { MultipleSelect } from "."

export const MultipleSelectWithAddItemOption = ({
  options: propOptions,
  onChange,
  value,
  addItemLabel = "Add option",
  notFoundLabel = "not found",
  ...rest
}) => {
  const [inputValue, setInputValue] = useState("")
  const [localOptions, setLocalOptions] = useState([])
  const selectRef = React.useRef(null)

  useEffect(() => {
    setLocalOptions(propOptions || [])
  }, [propOptions])

  const handleChange = (newValue) => {
    if (onChange) {
      onChange(newValue)
    }
  }

  const handleSearch = (text) => {
    setInputValue(text)
  }

  const addItem = (e) => {
    if (e) {
      e.preventDefault()
      e.stopPropagation()
    }

    if (!inputValue || inputValue.trim() === "") return

    if (localOptions.some((option) => option.name.toLowerCase() === inputValue.toLowerCase())) {
      return
    }

    const newOption = {
      id: inputValue.trim(),
      name: inputValue.trim()
    }

    setLocalOptions([...localOptions, newOption])

    const newValue = [...(value || []), newOption.id]
    handleChange(newValue)

    setInputValue("")

    if (selectRef.current && selectRef.current.select) {
      selectRef.current.select.blur()
      setTimeout(() => {
        selectRef.current.select.focus()
      }, 0)
    }
  }

  const isInputExisting = inputValue && !localOptions.some((o) => o.name.toLowerCase() === inputValue.toLowerCase())

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && isInputExisting && inputValue.trim() !== "") {
      e.preventDefault()
      e.stopPropagation()
      addItem()
    }
  }

  const onPreventMouseDown = (e) => {
    if (e) {
      e.preDefault()
      e.stopPropagation()
    }
  }

  return (
    <MultipleSelect
      ref={selectRef}
      options={localOptions}
      onChange={handleChange}
      value={value}
      onSearch={handleSearch}
      onKeyDown={handleKeyDown}
       disabledOptions={rest.disabledOptions}
      dropdownRender={(menu) => (
        <>
          {menu}
          {isInputExisting && inputValue.trim() !== "" && (
            <>
              <Divider style={{ margin: "8px 0" }} />
              <div style={{ display: "flex", flexWrap: "nowrap", padding: "8px" }} onMouseDown={onPreventMouseDown}>
                <span style={{ flex: "auto" }}>
                  "{inputValue}" {notFoundLabel}
                </span>
                <Button
                  type="link"
                  icon={<PlusOutlined />}
                  onClick={addItem}
                  onMouseDown={onPreventMouseDown}
                  style={{ whiteSpace: "nowrap" }}
                >
                  {addItemLabel}
                </Button>
              </div>
            </>
          )}
        </>
      )}
      filterOption={(input, option) => {
        return option.children.toLowerCase().includes(input.toLowerCase())
      }}
      searchValue={inputValue}
      {...rest}
    />
  )
}
